export const USER = {
  TYPES: [
    {
      id: 1,
      name: "External"
    },
    {
      id: 2,
      name: "Internal"
    }
  ],
  isExternalUser(userTypeId: number): boolean {
    return userTypeId === 1;
  },
  isInternalUser(userTypeId: number): boolean {
    return userTypeId === 2;
  },
  PERMISSIONS: {
    manageUsers: 7,
    manageProducts: 6,
    manageWorkflows: 3,
    manageContent: 9
  },
  FEATURES: {
    manageProgrammes: 1,
    manageCurriculums: 2,
    manageCms: 8,
    manageLogs: 9
  },
  ERRORS: {
    passwordLength: "The password must contain at least 6 characters",
    passwordUpdate: "Password not updated",
    nameLength: "The username must contain at least 1 character",
    firstNameLength: "The first name must contain at least 1 character",
    lastNameLength: "The last name must contain at least 1 character",
    typeError: "Select the user type"
  },
  MESSAGES: {
    seabInternalUser:
      "Internal users can view and edit all questions and tests within the CMS.",
    seabExternalUser:
      "External users can only view and edit the questions and tests they have personally authored. They cannot access or modify any content created by other users."
  }
};
